import React, { useEffect } from "react";
import { CommonButton } from "./CommonButton";
import { CommonHeading } from "./CommonHeading";
import PeopleIcon from "assets/svgIcons/SideNav/PeopleIcon";
import Settings from "assets/svgIcons/PeopleSubSideNav/Settings";
import Car from "assets/svgIcons/PeopleSubSideNav/CarIcon";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import {
  SideNavTabsWrapper,
  SubSideNavTabs,
} from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export const PeopleSideNav = () => {
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName === "People" ||
      getSubnavName === "Groups" ||
      getSubnavName === "Vehicles"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("People");
      localStorage.setItem("mapSideNavTabState","People")
    }
  }, []);

  return (
    <div>
      <CommonHeading labelText={"People"} />
      <SideNavTabsWrapper>
        <SubSideNavTabs>
          <Tooltip title={t("People")} arrow>
            <span>
              <CommonButton
                labelText={"People"}
                displayText={"People"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "People");
                  mapSideNavTabState.set("People");
                }}
              >
                <PeopleIcon
                  color={
                    mapSideNavTabState.get() === "People"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip title={t("Groups")} arrow>
            <span className="display">
              <CommonButton
                labelText={"Groups"}
                displayText={"Groups"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Groups");
                  mapSideNavTabState.set("Groups");
                }}
              >
                <Settings
                  color={
                    mapSideNavTabState.get() === "Groups"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip title={t("Vehicles")} arrow>
            <span className="display">
              <CommonButton
                labelText={"Vehicles"}
                displayText={"Vehicles"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Vehicles");
                  mapSideNavTabState.set("Vehicles");
                }}
              >
                <Car
                  color={
                    mapSideNavTabState.get() === "Vehicles"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>
        </SubSideNavTabs>
      </SideNavTabsWrapper>
    </div>
  );
};
